/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Type of filter to list options for
 */
export const FilterType = {
  ApiKey: "api_key",
  User: "user",
  InternalUser: "internal_user",
  Agent: "agent",
} as const;
/**
 * Type of filter to list options for
 */
export type FilterType = ClosedEnum<typeof FilterType>;

/**
 * Payload for listing filter options
 */
export type ListFilterOptionsPayload = {
  /**
   * Optional event source filter for the option list
   */
  eventSource?: string | undefined;
  /**
   * Type of filter to list options for
   */
  filterType: FilterType;
  /**
   * Start time in ISO 8601 format
   */
  from: Date;
  /**
   * End time in ISO 8601 format
   */
  to: Date;
};

/** @internal */
export const FilterType$outboundSchema: z.ZodMiniEnum<typeof FilterType> = z
  .enum(FilterType);

/** @internal */
export type ListFilterOptionsPayload$Outbound = {
  event_source?: string | undefined;
  filter_type: string;
  from: string;
  to: string;
};

/** @internal */
export const ListFilterOptionsPayload$outboundSchema: z.ZodMiniType<
  ListFilterOptionsPayload$Outbound,
  ListFilterOptionsPayload
> = z.pipe(
  z.object({
    eventSource: z.optional(z.string()),
    filterType: FilterType$outboundSchema,
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
  }),
  z.transform((v) => {
    return remap$(v, {
      eventSource: "event_source",
      filterType: "filter_type",
    });
  }),
);

export function listFilterOptionsPayloadToJSON(
  listFilterOptionsPayload: ListFilterOptionsPayload,
): string {
  return JSON.stringify(
    ListFilterOptionsPayload$outboundSchema.parse(listFilterOptionsPayload),
  );
}
